import LangEn from '@/locales/lang/en'
import LangPtbr from '@/locales/lang/ptbr'

export default {
  ...LangEn,
  ...LangPtbr
}
